var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:'news' + _vm.$root.$children[0].viewComponentKey,class:{ 'py-5': _vm.$root.$children[0].isAdminstrationMode }},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('h2',{attrs:{"id":"navigation-title"}})])],1),_c('b-row',[_c('b-col',[_c('div',{attrs:{"id":"renderer"}})])],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }